import { OrderActivityActorType, OrderActivityLog } from '@/features/orders/types/app'
import { TFunction } from 'i18next'

export const getActivityActorLabel = (
    activityLog: OrderActivityLog,
    t: TFunction<'app'>
): string | null => {
    const actor = activityLog.actor

    if (!actor?.type) return null

    if (actor.type === OrderActivityActorType.Customer) {
        return t('order.detail.history.actor.customer')
    }

    if (actor.type === OrderActivityActorType.TerminalUserProfile) {
        const terminalUserLabel = t('order.detail.history.actor.terminalUserProfile')

        if (actor.label && actor.description) {
            return `${terminalUserLabel} ${actor.label} (${actor.description})`
        }

        if (actor.label) {
            return `${terminalUserLabel} ${actor.label}`
        }

        return terminalUserLabel
    }

    if (actor.type === OrderActivityActorType.Driver) {
        const driverLabel = t('order.detail.history.actor.driver')

        if (actor.label) {
            return `${driverLabel} ${actor.label}`
        }

        return driverLabel
    }

    if (actor.type === OrderActivityActorType.System) return null

    return actor.label
}
